export default __webpack_public_path__ + "static/media/pedro.0250fe7e.png";